import React, { useReducer } from "react";
import axios from "axios";

import URL from "../../common/variables";
import { encodeURLByObject } from "../../common/functions";
import Banner from "../Banner/Banner";
import Pagination from "../Pagination/Pagination";

import { SearchReducer } from "./SearchReducer";
import SearchField from "./SearchField";
import RowSearch from "./RowSearch";

import "./Search.scss";

const Banners = [
  "https://beta.jornada.com.mx/theme/img/728x90.png",
  "https://beta.jornada.com.mx/theme/img/300x250.png",
];

const randomBanner = () => Banners[Math.floor(Math.random() * Banners.length)];

const Search = () => {
  const initialState = {
    initial: true,
    isLoading: false,
    showPagination: false,
    showPanelSearch: true,
    totalCount: 0,
    next: null,
    previous: null,
    results: [],
  };
  const [state, dispatch] = useReducer(SearchReducer, initialState);

  const onSubmit = (values) => {
    const { search, filters } = values;
    dispatch({ type: "LOADING_SEARCH_DATA" });

    if (!filters) {
      axios.get(`${URL}/articles/?search=${search}`).then((response) => {
        const { count, next, previous, results } = response.data;

        dispatch({ type: "GET_SEARCH_DATA", count, next, previous, results });
        dispatch({ type: "TOGGLE_SEARCH_DISPLAY" });
      });
    } else {
      let parseFilters;

      if (filters.tags__tag) {
        parseFilters = {
          ...filters,
          tags__tag:
            filters.tags__tag.length > 0
              ? filters.tags__tag.reduce(
                  (acc, cur) => `${acc}&tags__tag=${cur}`
                )
              : [],
        };
      } else {
        parseFilters = { ...filters };
      }

      axios
        .get(
          `${URL}/articles/?search=${search}&${encodeURLByObject(parseFilters)
            .replace(/%26/g, "&")
            .replace(/%3D/g, "=")}`
        )
        .then((response) => {
          const { count, next, previous, results } = response.data;

          dispatch({ type: "GET_SEARCH_DATA", count, next, previous, results });
          dispatch({ type: "TOGGLE_SEARCH_DISPLAY" });
        });
    }
  };

  const getSearch = (url) => {
    dispatch({ type: "LOADING_SEARCH_DATA" });

    axios.get(url).then((response) => {
      const { count, next, previous, results } = response.data;

      dispatch({ type: "GET_SEARCH_DATA", count, next, previous, results });
    });
  };

  const toggleDisplay = () => dispatch({ type: "TOGGLE_SEARCH_DISPLAY" });

  return (
    <div id="search">
      <SearchField
        onSubmit={onSubmit}
        isDisplay={state.showPanelSearch}
        toggleDisplay={toggleDisplay}
      >
        {state.totalCount === 0 && <div className="search-results" />}

        {state.totalCount === 0 && state.isLoading && (
          <div>Cargando la búsqueda...</div>
        )}

        {!state.isLoading && state.totalCount === 0 && !state.initial && (
          <div>Sin resultados de búsqueda</div>
        )}

        {state.totalCount > 0 && (
          <div className="form__search-status">
            <div className="box-title">
              <p className="mt-1 mb-1">
                <i className="fas fa-chart-bar"></i> Resultados{" "}
                <strong>{state.totalCount}</strong> de las búsquedas
              </p>
              <div className="content-block">
                <Pagination
                  key={0}
                  {...state}
                  getFnRequest={getSearch}
                  results={[]}
                />
                {state.isLoading && (
                  <div className="text-center loading">Cargando...</div>
                )}
              </div>
            </div>

            <div>
              {state.results.map((result, idx) => (
                <div key={idx}>
                  {/* Banner section */}
                  {idx % 3 === 0 && (
                    <Banner key={`banner-${idx}`} url={randomBanner()} />
                  )}
                  {/* Row */}
                  <RowSearch result={result} />
                </div>
              ))}
            </div>

            <div className="content-block">
              <Pagination
                key={1}
                {...state}
                getFnRequest={getSearch}
                results={[]}
              />
            </div>
          </div>
        )}
      </SearchField>
    </div>
  );
};

export default Search;
